
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1077.13 675.98"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('g',{attrs:{"data-name":"Capa 1"}},[_c('circle',{attrs:{"cx":"538.56","cy":"337.99","r":"276.58"}}),_c('circle',{attrs:{"cx":"329.71","cy":"198.09","r":"112.36","fill":"#fff"}}),_c('path',{attrs:{"d":"M538.56 676a595.89 595.89 0 01-311.71-87.75A599.4 599.4 0 0111.3 359.2L0 338l11.3-21.21a597.14 597.14 0 011054.53 0l11.3 21.21-11.3 21.21a599.5 599.5 0 01-215.56 229A595.84 595.84 0 01538.56 676zM102.92 338A509.26 509.26 0 00274 511.29a507.28 507.28 0 00529.05 0A509.26 509.26 0 00974.21 338a506.84 506.84 0 00-871.29 0z"}})])])])
          )
        }
      }
    